import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {usePageURLContext} from "../../../contexts/pageURLContext";
import {requestSims} from "../../../redux/Actions/sims.actions";
import {
  getSimsList,
  getSimsPaginationUrls,
  getTotalCount,
} from "../../../redux/Selectors/sim.selector";
import {generateQueryUrl} from "../../../helpers/generateQueryUrl";
import {simListURL} from "./simTable.constants";

export const useFetchSims = () => {
  const {pageUrl} = usePageURLContext();
  const dispatch = useDispatch();

  const freshFetch = () => {
    dispatch(requestSims());
  };

  const refetch = () => {
    dispatch(requestSims(pageUrl));
  };

  return {refetch, freshFetch};
};

export const useSimTableData = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const dispatch = useDispatch();
  const {refetch, freshFetch} = useFetchSims();
  const {setPageUrl} = usePageURLContext();
  const sims = useSelector(getSimsList);
  const simUrls = useSelector(getSimsPaginationUrls);
  const totalCount = useSelector(getTotalCount);
  useEffect(() => {
    freshFetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchAfterDelete = () => {
    if (sims.length === 1) {
      // If the last sim on the current page is deleted, reset to the first page
      setCurrentPage(1);
      setPageUrl("");
      freshFetch();
    } else {
      refetch();
    }
  };

  const handlePageChange = (page) => {
    const url = currentPage < page ? simUrls?.nextUrl : simUrls?.prevUrl;
    dispatch(requestSims(url));
    setCurrentPage(page);
    setPageUrl(url);
  };

  const paginationConfig = {
    currentPage,
    onPageChange: handlePageChange,
  };

  const handleSearch = (tokens) => {
    if (tokens?.length > 0) {
      const searchUrl = generateQueryUrl(simListURL, tokens);
      dispatch(requestSims(searchUrl));
      setPageUrl(searchUrl);
      setCurrentPage(1);
    } else {
      freshFetch();
      setPageUrl("");
      setCurrentPage(1);
    }
  };
  return {fetchAfterDelete, handleSearch, paginationConfig, sims, totalCount};
};
